import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    intro: null,
    coupons: [],
    shopIds: [],
    environment: [],
    feature: [],
    branch: [],
    corporation: {},
    lecture: {
      name: null,
      list: []
    },
    detail: {
      about : null,
      story: null,
      concept: null,
      honor: [],
      media: [],
      cert: [],
      event: null
    },
    follow: false,
    followed: false,
    content:null,
    name: null,
    login: null,
    error:0
  },
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js